import React from "react";
import PieChart from "../../components/Charts/PieChart";

function PieChartCard() {
  const series = [
    { name: "Analytics", data: 25 },
    { name: "Sales", data: 35 },
    { name: "Marketing", data: 20 },
    { name: "Development", data: 20 },
  ];

  return (
    <div className="card portal-card flex-grow-1">
      <div className="card-body">
        <PieChart series={series} title="부서별 현황" />
      </div>
    </div>
  );
}

export default PieChartCard;
